export default "__VITE_ASSET__ZaMwXemk__"